import React, {memo} from 'react';

import {styleMods} from '../utils';

import style from './block.module.scss';

 export default memo(
	/**
	 * @param {{
	 *   children: React.ReactNode,
	 *   padding?: boolean,
	 *   paddingX?: boolean,
	 *   paddingY?: boolean,
	 *   background?: boolean,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function Block({
		children,
		padding,
		paddingX,
		paddingY,
		background,
	}) {
		const inner = (
			<div className={style.inner}>
				{children}
			</div>
		);

		const inner2 = (() => {
			if (background) {
				return (
					<div className={style.background}>
						{inner}
					</div>
				);
			} else {
				return inner;
			}
		})();

		return (
			<article
				className={styleMods(style, 'base', {
					paddingX: padding || paddingX || false,
					paddingY: padding || paddingY || false,
				})}
			>
				{inner2}
			</article>
		);
	}
);
